import { MEMBER_INVITE_STATUS } from "@/constants/board";
import useAppStore from "@/context/store";
import { Button } from "antd";
import styles from "./index.module.less";

export * from "./Members";

/**
 * 邀请操作按钮
 * @param param0
 * @returns
 */
export function InviteAction({
  user,
  onClick,
  status,
}: {
  user: IUser;
  onClick?: () => void;
  status?: MEMBER_INVITE_STATUS;
}) {
  const currentUser = useAppStore((s) => s.user);

  const isInviting = status === MEMBER_INVITE_STATUS.INVITING;

  // 已经加入协作，需要显示退出或移除
  const beMemberText = user.user_id === currentUser.user_id ? "退出" : "移除";

  const buttonName = isInviting
    ? "已邀请"
    : status === MEMBER_INVITE_STATUS.NORMAL
    ? beMemberText
    : "邀请";

  return (
    <Button
      onClick={onClick}
      shape="round"
      disabled={isInviting}
      data-gd-click="button_click"
      data-button-name={buttonName}
      className={styles.button}
    >
      {buttonName}
    </Button>
  );
}
